import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './GetIdCardPrompt.module.css';

const GetIdCardPrompt = () => {
    const navigate = useNavigate();

    const handleProceed = () => {
        navigate('/id-card-ad');
    };

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <h1 className={styles.title}>Ghareebo card khreed lo</h1>
                <p className={styles.subtitle}>You don't have an eID card yet. Get one now!</p>
                <button onClick={handleProceed} className={styles.proceedButton}>
                    Proceed
                </button>
            </div>
        </div>
    );
};

export default GetIdCardPrompt;
